import {
  RefObject, useEffect, useRef, useState,
} from 'react';

let isIntersectingTimeout: NodeJS.Timeout;
let notIntersectingTimeout: NodeJS.Timeout;

export default function useOnScreen<T extends Element>(
  initiallyVisible: boolean = false,
  delay?: number,
): [RefObject<T>, boolean] {
  const [isIntersecting, setIsIntersecting] = useState(initiallyVisible);

  const ref = useRef<T>(null);

  const callbackWithDelay = (intersecting: boolean) => {
    if (intersecting) {
      isIntersectingTimeout = setTimeout(() => {
        setIsIntersecting(true);
      }, delay);
      clearTimeout(notIntersectingTimeout);
    } else {
      notIntersectingTimeout = setTimeout(() => {
        setIsIntersecting(false);
      }, delay);
      clearTimeout(isIntersectingTimeout);
    }
  };

  const observer = new IntersectionObserver(
    ([entry]) => (delay
      ? callbackWithDelay(entry.isIntersecting)
      : setIsIntersecting(entry.isIntersecting)
    ),
  );

  useEffect(() => {
    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => observer.disconnect();
  }, []);

  return [ref, isIntersecting];
}
